import React from 'react';
import '../../../css/style.scss'
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import {themeButtons} from "../../../css/themeButtons";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const Modal = props => {
    const {className, toggleShow, show, size, title, textBtnOk, textBtnCancel, showBtnOk, btnOkAction, disableBtnOk, btnCancelAction, isSubmitting, fullScreen} = props
    if (!show) {
        return null;
    }

    const handleClick = () => {
        if (btnOkAction) {
            btnOkAction()
        } else {
            toggleShow()
        }
    }

    const buttons = themeButtons();

    return (<Dialog
            disableEnforceFocus
            open={show}
            fullScreen={fullScreen}
            TransitionComponent={Transition}
            keepMounted
            className={className}
            fullWidth={true}

            maxWidth={size ? size : "sm"}
            aria-labelledby="dialog-title"
        >
            <DialogTitle id="dialog-title">{title}</DialogTitle>
            <DialogContent className={"mb-3"}>
                {props.children}
            </DialogContent>

            <DialogActions className={fullScreen ? 'align-items-stretch' : ''}>
                {showBtnOk !== false && <Button type="submit" onClick={handleClick} disabled={disableBtnOk} variant="contained" className={`${buttons.btnGreen}`}>
                    {textBtnOk || "Отправить"}
                </Button>}
                <Button onClick={btnCancelAction ? btnCancelAction : toggleShow} variant="contained" className={`${buttons.btnDanger}`}>
                    {textBtnCancel || "Закрыть"}
                </Button>
            </DialogActions>
        </Dialog>
    );

}


export default Modal;